import React from 'react'
import Address from './address'
import PostalCodeAutocomplete from './PostalCode'
import CityAutocomplete from './city'
import StateAutocomplete from './state'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

function Location ({
  localAddress,
  setLocalAddress,
  localCity,
  setLocalCity,
  localState,
  setLocalState,
  localPostalCode,
  setLocalPostalCode,
  localCountry,
  setLocalCountry
}) {
  const handleCountryChange = event => {
    setLocalCountry(event.target.value)
  }

  return (
    <div className={styles.locationSection}>
      <h1 className={styles.locationTitle}>Location</h1>
      <div className={styles.locationInputContainer}>
        <Address
          localAddress={localAddress}
          setLocalAddress={setLocalAddress}
        />
        <CityAutocomplete localCity={localCity} setLocalCity={setLocalCity} />
        <StateAutocomplete
          localState={localState}
          setLocalState={setLocalState}
        />
        <PostalCodeAutocomplete
          localPostalCode={localPostalCode}
          setLocalPostalCode={setLocalPostalCode}
        />
        <div className={styles.locationInputWrapper}>
          <div className={styles.inlineLabel}>
            <label className={styles.locationLabel} htmlFor='country'>
              Country
            </label>
            <Tooltip
              title='The country of the business.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Country help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <select
            className={styles.locationInputDropBox}
            name='countries'
            id='country'
            value={localCountry}
            onChange={handleCountryChange}
          >
            <option value=''>Any</option>
            <option value='US'>US</option>
            <option value='CA'>Canada</option>
          </select>
        </div>
      </div>
    </div>
  )
}

export default Location
